/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'disqus': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" _fill="#229cff" d="M0 0h32v32H0V0z"/><path pid="1" _fill="#fff" d="M16.44 12.941h-1.427v6.06h1.427a3.03 3.03 0 100-6.06z"/><path pid="2" _fill="#fff" d="M16.468 4.169C9.934 4.169 4.637 9.466 4.637 16c0 1.744.378 3.399 1.055 4.89l-1.991 4.748 5.164-.574a11.787 11.787 0 007.603 2.766c6.534 0 11.831-5.297 11.831-11.831S23.002 4.168 16.468 4.168zm.363 17.814h-5.146V9.96h5.146c1.66 0 3.163.673 4.25 1.761s1.761 2.59 1.761 4.25a6.01 6.01 0 01-6.011 6.012z"/>'
  }
})
